import { z } from 'zod';
import { CardType } from '../../payment.types';
import {
    CardPointeGatewayTransactionDetailsType,
    type CardPointeNormalizedGatewayTransactionDetails,
    CloverGatewayTransactionDetailsType,
    type CloverNormalizedGatewayTransactionDetails,
    type IpgGatewayTransactionDetails,
} from '../../types/ipg/ipg-gateway-transaction-details-registry';
import { CardPointeGatewayId } from '../../types/ipg/cardpointe/cardpointe-system-constants';
import { CloverGatewayId } from '../../types/ipg/clover/clover-system-constants';
import { ValorGatewayTransactionDetailsSchema } from './valor/valor-payment.schemas';

export const CardPointeNormalizedGatewayTransactionDetailsSchema: z.ZodType<CardPointeNormalizedGatewayTransactionDetails> =
    z.object({
        gateway_id: z.literal(CardPointeGatewayId),
        gateway_transaction_details_type: z.literal(
            CardPointeGatewayTransactionDetailsType
        ),
        gateway_transaction_details_version: z.literal(1),
        gateway_txn_id: z.string().min(1),
        base_amount: z.number().nonnegative(),
        total_amount: z.number().nonnegative(),
        total_fee_amount: z.number().nonnegative(),
        total_tax_amount: z.number().nonnegative(),
        is_void: z.boolean(),
        is_settled: z.boolean(),
        refund_amount: z.number().nonnegative(),
        refund_count: z.number().int().nonnegative(),
        card_brand: z.string().min(1).optional(),
        card_last4: z.string().regex(/^\d{4}$/).optional(),
        cardholder_name: z.string().min(1).optional(),
        card_type: z.enum(CardType).optional(),
        settlement_status: z.string().min(1).optional(),
        authorization_code: z.string().min(1).optional(),
        batch_id: z.string().min(1).optional(),
    });

export const CloverNormalizedGatewayTransactionDetailsSchema: z.ZodType<CloverNormalizedGatewayTransactionDetails> =
    z.object({
        gateway_id: z.literal(CloverGatewayId),
        gateway_transaction_details_type: z.literal(
            CloverGatewayTransactionDetailsType
        ),
        gateway_transaction_details_version: z.literal(1),
        gateway_txn_id: z.string().min(1),
        base_amount: z.number().nonnegative(),
        total_amount: z.number().nonnegative(),
        total_fee_amount: z.number().nonnegative(),
        total_tax_amount: z.number().nonnegative(),
        is_void: z.boolean(),
        is_settled: z.boolean(),
        refund_amount: z.number().nonnegative(),
        refund_count: z.number().int().nonnegative(),
        card_brand: z.string().min(1).optional(),
        card_last4: z.string().regex(/^\d{4}$/).optional(),
        cardholder_name: z.string().min(1).optional(),
        card_type: z.enum(CardType).optional(),
        settlement_status: z.string().min(1).optional(),
        authorization_code: z.string().min(1).optional(),
        batch_id: z.string().min(1).optional(),
    });

export const IpgGatewayTransactionDetailsSchema: z.ZodType<IpgGatewayTransactionDetails> =
    z.union([
        ValorGatewayTransactionDetailsSchema,
        CardPointeNormalizedGatewayTransactionDetailsSchema,
        CloverNormalizedGatewayTransactionDetailsSchema,
    ]);
